import {
  IAbilityLevelUpBody,
  IProfession,
  IUserProfession,
  ILevelUpResponse
} from "store/apis/professionsAPI/professions.types"
import { TAGS, api } from "../../api.ts"

const professionsApi = api.enhanceEndpoints({
  addTagTypes: [
    TAGS.PROFESSIONS,
    TAGS.USER,
    TAGS.SEASON_LEADERBOARD,
    TAGS.BALANCE
  ]
})

export const professionsEndpoints = professionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllProfessions: builder.query<IProfession[], void>({
      query: () => ({
        url: "/professions/templates",
        method: "GET"
      }),
      providesTags: (professions) =>
        professions
          ? [
              ...professions.map(({ _id }: IProfession) => ({
                type: TAGS.PROFESSIONS as const,
                id: _id
              })),
              { type: TAGS.PROFESSIONS, id: "LIST" }
            ]
          : [{ type: TAGS.PROFESSIONS, id: "LIST" }]
    }),
    getUserProfessions: builder.query<IUserProfession[], void>({
      query: () => ({
        url: "/professions/levels",
        method: "GET"
      }),
      providesTags: (professions) =>
        professions
          ? [
              ...professions.map(({ type }: IUserProfession) => ({
                type: TAGS.PROFESSIONS as const,
                id: type
              })),
              { type: TAGS.PROFESSIONS, id: "LIST" }
            ]
          : [{ type: TAGS.PROFESSIONS, id: "LIST" }]
    }),
    abilityLevelUp: builder.mutation<ILevelUpResponse, IAbilityLevelUpBody>({
      query: (data) => ({
        url: "/professions/levels",
        method: "PATCH",
        data
      }),
      extraOptions: { maxRetries: 2 },
      invalidatesTags: (res, _error, { type }) => [
        { type: TAGS.USER, id: "rank" },
        { type: TAGS.PROFESSIONS, id: type },
        { type: TAGS.USER, id: `USER_LEADERBOARD_STATS_${res?.userId}` },
        { type: TAGS.SEASON_LEADERBOARD }
      ]
    }),
    resetProfession: builder.mutation<any, string>({
      query: (type) => ({
        url: "professions/reset-professions",
        method: "PATCH",
        data: { type }
      }),
      invalidatesTags: (res, _error, type) => [
        { type: TAGS.USER, id: `USER_LEADERBOARD_STATS_${res.userId}` },
        { type: TAGS.PROFESSIONS, id: type },
        { type: TAGS.SEASON_LEADERBOARD },
        { type: TAGS.BALANCE }
      ]
    })
  })
})
